import CoursesView from './Courses';

export default CoursesView;
